import React from "react";
import axios from "axios";
import Loading from "./Loading";
import CampaignList from "./CampaignList";
import CampaignView from "./CampaignView";
import ProductView from "./ProductView";
import { getWeekNumber } from "../utils/snippets";

function TaperView() {
  const curWeek = getWeekNumber(
    new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
  );
  const [campaign, setCampaign] = React.useState(undefined);
  const [product, setProduct] = React.useState(undefined);
  const [ads, setAds] = React.useState([]);
  const [tapes, setTapes] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [reload, setReload] = React.useState(true);
  const [selectedWeek, setSelectedWeek] = React.useState(curWeek);
  React.useEffect(() => {
    window.history.pushState(
      { role: "teippaus" },
      "CampaignList",
      "?campaignList"
    );
  }, []);
  let weekSelect = [];
  for (let i = 1; i < 53; i++) {
    weekSelect.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  window.onpopstate = (event) => {
    console.log(event);
    setCampaign(event.state.campaign);
    setProduct(event.state.product);
    setReload(reload + 1);
  };
  React.useEffect(() => {
    setLoading(true);
    axios
      .get(process.env.REACT_APP_BACKEND_URL + "/getAds")
      .then((res) => {
        setAds(res.data.ads);
        setTapes(res.data.tapes);
        setLoading(false);
      })
      .catch((reason) => {
        console.log("/getAds failed", reason);
        alert("Datan haku epäonnistui \nVirheviesti:" + reason.message);
      });
  }, [reload]);
  return (
    <div>
      {loading ? <Loading /> : ""}
      {campaign === undefined ? (
        <CampaignList
          ads={ads}
          setCampaign={setCampaign}
          tapes={tapes}
          selectedWeek={selectedWeek}
          setSelectedWeek={setSelectedWeek}
        />
      ) : product === undefined ? (
        <CampaignView
          setCampaign={setCampaign}
          setProduct={setProduct}
          campaign={campaign}
          tapes={tapes}
          ads={ads}
        />
      ) : (
        <ProductView
          setProduct={setProduct}
          product={product}
          reload={reload}
          setReload={setReload}
          tapes={tapes}
          ads={ads}
        />
      )}
    </div>
  );
}

export default TaperView;
